import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { VeraWordmark } from '../components/icons/VeraWordmark';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await resetPassword(email);
      setSuccess(true);
    } catch (err: any) {
      console.error('Error sending password reset email:', err);
      setError(err.message || 'Failed to send password reset email');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div
        style={{
          minHeight: '100vh',
          backgroundColor: 'var(--color-primary)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--spacing-4)',
        }}
      >
        <div className="card" style={{ width: '100%', maxWidth: '450px', textAlign: 'center' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 'var(--spacing-4)',
            }}
          >
            <VeraWordmark size={48} />
          </div>

          <h1 style={{ fontSize: 'var(--text-3xl)', marginBottom: 'var(--spacing-4)' }}>
            Check Your Email
          </h1>

          <div
            className="alert"
            style={{
              backgroundColor: 'var(--color-success-light, #dcfce7)',
              color: 'var(--color-success-dark, #166534)',
              padding: 'var(--spacing-4)',
              borderRadius: 'var(--radius-md)',
              marginBottom: 'var(--spacing-6)',
              border: '1px solid var(--color-success, #22c55e)'
            }}
          >
            <p style={{ marginBottom: 'var(--spacing-2)' }}>
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p style={{ fontSize: 'var(--text-sm)' }}>
              Click the link in the email to reset your password. The link will expire in 1 hour.
            </p>
          </div>

          <div style={{ marginBottom: 'var(--spacing-4)' }}>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
              Didn't receive the email? Check your spam folder or{' '}
              <button
                onClick={() => setSuccess(false)}
                style={{
                  color: 'var(--color-secondary)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 0,
                  fontWeight: 'var(--font-medium)',
                }}
              >
                try again
              </button>
            </p>
          </div>

          <button
            onClick={() => navigate('/login')}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--color-primary)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--spacing-4)',
      }}
    >
      <div className="card" style={{ width: '100%', maxWidth: '450px' }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-6)' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 'var(--spacing-4)',
            }}
          >
            <VeraWordmark size={48} />
          </div>
          <h1 style={{ fontSize: 'var(--text-3xl)', marginBottom: 'var(--spacing-2)' }}>
            Reset Your Password
          </h1>
          <p style={{ color: 'var(--color-gray-500)', fontSize: 'var(--text-xs)', marginBottom: 'var(--spacing-2)' }}>
            VERA — Verified Evidence, Real Accountability
          </p>
          <p style={{ color: 'var(--color-gray-600)', fontSize: 'var(--text-sm)' }}>
            Enter your email address and we'll send you a link to reset your password
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email Address *
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoFocus
            />
          </div>

          {error && (
            <div className="alert alert-error" style={{ marginBottom: 'var(--spacing-4)' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', marginBottom: 'var(--spacing-4)' }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 'var(--spacing-4)' }}>
          <button
            onClick={() => navigate('/login')}
            style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--color-secondary)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
            onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};
